import { Component, Host, h, Prop } from '@stencil/core';
import { Color, PulseStyle } from './types';

export interface AhaColorDot extends HTMLAhaColorDotElement {}

@Component({
  tag: 'aha-color-dot',
  styleUrl: 'aha-color-dot.css',
  shadow: true,
})
export class AhaColorDot {
  /** Color of dot. Can choose a pre-defined option or set to any valid CSS color. */
  @Prop({ reflect: true }) color!: Color;

  /** Whether or not dot is showing pulsing animation. */
  @Prop({ reflect: true }) pulse: boolean = false;

  /** Style of pulsing animation. */
  @Prop({ reflect: true, attribute: 'pulse-style' }) pulseStyle!: PulseStyle;

  /** Size of outer dot. Accepts any valid CSS string (ex. `10px`, `2em`, `var(--my-cutom-height)`, etc.). */
  @Prop({ reflect: true }) size!: string;

  render() {
    const style = Object.create(null);
    if (typeof this.size !== 'undefined') {
      style['--aha-color-dot--size'] = this.size;
    }
    if (typeof this.pulseStyle !== 'undefined') {
      style['--aha-color-dot--pulse-style'] = this.pulseStyle;
    }

    return (
      <Host style={style}>
        <div id="dot"></div>
      </Host>
    );
  }
}
